import { FC, useEffect, useRef } from "react";
import { from, interval, startWith, Subject, switchMap, takeUntil } from "rxjs";
import { ProgressBar } from "primereact/progressbar";
import Sidebar from "../Sidebar/Sidebar";
import {
  CardContainer,
  CardContent,
  ProgressReportLabel,
  SidebarContainerCommon,
  SidebarTitle,
} from "./AdminReportStyle";
import { getErrorValueResponse } from "../../common/error/Error";
import { HTTP_METHODS } from "../../utils/constants";
import { LoadingSidebar } from "../../common/components/LoadingSidebar/LoadingSidebar";
import { networkBackendRequest } from "../../utils/networkUtils";
import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import IconDownload from "../../images/icon_download_sidebar.svg";
import IconDownloadHistory from "../../images/icon_download_history.svg";
import "./AdminReport.css";
import { ReportsDatum, TrackingReport } from "./interfaces/Volantes.interfaces";
import { formatGetTimeLabel } from "../../utils/DatesFns";
import { ReportDownloadExecutor } from "./interfaces/Report.interfaces";
import {
  INTERVAL_10_SECONDS,
  PROCESSING,
  SUCCESS,
} from "../../utils/valueStaticConstants";
interface IAdminReportSidebar {
  onOutsideClick: () => void;
  captureErrorSidebar: (captureError: string) => void;
}

export const ReportSidebarConvertResponse = (resp: TrackingReport) => {
  const report_data_tracking = resp.reports_data.map((reportData) => {
    return {
      id: reportData.id,
      report_doc: reportData.report_doc,
      progress: reportData.progress,
      category: reportData.category,
      created_at: reportData.created_at,
      updated_at: reportData.updated_at,
    };
  });
  return {
    report_data_tracking,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};

export const AdminReportSidebar: FC<IAdminReportSidebar> = (props) => {
  const { onOutsideClick, captureErrorSidebar } = props;

  const destroy$Ref = useRef(new Subject());
  const destroy$: any = destroy$Ref.current;

  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  const getReportTrackStatus = useAsyncExecutor2(
    (_) => {
      const destroy$ = destroy$Ref.current;
      return interval(INTERVAL_10_SECONDS).pipe(
        takeUntil(destroy$),
        startWith(null),
        switchMap(() => {
          const request = networkBackendRequest(
            `/reports/track-status/`,
            HTTP_METHODS.GET,
            undefined,
            undefined
          )
            .then((response) => response.json())
            .then(ReportSidebarConvertResponse);
          return from(request);
        })
      );
    },
    {
      onSuccess: () => {},
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        captureErrorSidebar(errorMessage);
        onOutsideClick();
        destroy$.next();
        destroy$.complete();
      },
    }
  );

  useEffect(() => {
    getReportTrackStatus.execute({});
    // eslint-disable-next-line
  }, []);

  const getDownloadReport = useAsyncExecutor(
    (params: ReportDownloadExecutor) => {
      const { idExcel } = params;
      return networkBackendRequest(
        "/files/presigned-download-url/",
        HTTP_METHODS.GET,
        {
          object_name: idExcel,
        }
      ).then((response) => response.json());
    },
    {
      onSuccess: (data) => {
        window.open(data.url);
      },
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        captureErrorSidebar(errorMessage);
      },
    }
  );
  return (
    <Sidebar
      onOutsideClick={() => {
        onOutsideClick();
        destroy$.next();
        destroy$.complete();
      }}
    >
      <SidebarContainerCommon width={"44rem"}>
        <SidebarTitle>
          <img src={IconDownloadHistory} alt="" />
          <div>{"VER DESCARGAS"}</div>
        </SidebarTitle>

        {getReportTrackStatus.status === PROCESSING && (
          <div
            style={{ width: "100%", paddingRight: "2rem", paddingLeft: "2rem" }}
          >
            <LoadingSidebar numItems={8} />
          </div>
        )}

        {getReportTrackStatus.status === SUCCESS && (
          <>
            <CardContainer>
              {getReportTrackStatus.data.report_data_tracking.map(
                (dataReportTrack: ReportsDatum, index: number) => {
                  return (
                    <CardContent
                      key={index}
                      className={
                        dataReportTrack.progress > 0 &&
                        dataReportTrack.progress < 100
                          ? "box"
                          : "success-box"
                      }
                    >
                      <div>
                        <div style={{ fontSize: "1.1rem" }}>
                          {formatGetTimeLabel(dataReportTrack.created_at)}
                        </div>
                        <div className="title-card">
                          {dataReportTrack.category.label}
                        </div>
                      </div>
                      <div>
                        {dataReportTrack.progress < 100 ? (
                          <div>
                            <ProgressReportLabel>
                              {dataReportTrack.progress}%
                            </ProgressReportLabel>
                            <ProgressBar
                              value={dataReportTrack.progress}
                              style={{ width: "6rem", height: "0.6rem" }}
                              showValue={false}
                            ></ProgressBar>
                          </div>
                        ) : (
                          <img
                            src={IconDownload}
                            alt=""
                            onClick={() => {
                              getDownloadReport.execute({
                                idExcel: dataReportTrack.report_doc,
                              });
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </div>
                    </CardContent>
                  );
                }
              )}
            </CardContainer>
          </>
        )}
      </SidebarContainerCommon>
    </Sidebar>
  );
};
